import {
  INVOICE_STATUS,
  INVOICE_TERMS,
  ORDER_STATUS,
  ProductType,
} from 'utils/constants';
import { Order } from 'utils/types';

export const INVOICE_MOCK_ORDERS: Order[] = [
  {
    _id: '6615f761667f29182641ebbb',
    leadId: '65f1903e49a280b2d15ec5fe',
    invoiceId: '6615f761667f29182641ebb6',
    status: INVOICE_STATUS.DRAFT,
    orderNumber: 'LC-5',
    items: [
      {
        _id: '66014a5907ea9b02e0d95185',
        type: ProductType.Amount,
        name: 'Web Development',
        price: 10000,
        description: 'Web Development service billed at a set amount',
      },
    ],
    subtotal: 10000,
    issuedAt: '2024-04-10T01:38:26.741Z',
    dueAt: '2024-04-09T16:00:00.000Z',
    lead: {
      accountStatusId: '',
      _id: '65f1903e49a280b2d15ec5fe',
      accountId: '63e05fe4d59adc087e305e08',
      firstName: 'John',
      lastName: 'Smith',
      fullName: 'John Smith',
      emailAddress: 'john.smith@leapify.com',
      accountUserId: [],
      createdAt: '2024-03-13T11:38:38.013Z',
      updatedAt: '2024-03-13T11:38:38.013Z',
      jobTitle: '',
      id: '65f1903e49a280b2d15ec5fe',
    },
    invoice: {
      status: ORDER_STATUS.ACTIVE,
      terms: INVOICE_TERMS.OneTime,
    },
  },
];
